<template>
  <div>
    <div class="title_box">
      <div class="title_box_left">
        <div class="data_title">我的数据</div>
        <el-radio-group v-model="selectValue" style="margin-right:10px">
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="周"></el-radio-button>
          <el-radio-button label="日"></el-radio-button>
        </el-radio-group>

        <el-date-picker
          v-if="selectValue == '月'"
          v-model="monthValue"
          @change="monthChange"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          format="yyyy-MM "
          value-format="yyyy-MM "
        >
        </el-date-picker>
        <el-date-picker
          v-model="date"
          v-if="selectValue == '周'"
          @change="weekChange"
          type="datetimerange"
          align="center"
          start-placeholder="开始周"
          end-placeholder="结束周"
          range-separator="~"
          class="date-class"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
        <el-date-picker
          v-if="selectValue == '日'"
          v-model="timeData"
          type="datetimerange"
          @change="dayChange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </div>

      <div class="font_num_summary">字数汇总：{{ total_num }}</div>
    </div>

    <div class="mydata_box">
      <div class="mydata_table">
        <el-table v-horizontal-scroll="'always'" :data="dataShow" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="connectionessay_name"
            label="书名"
            align="center"
            sortable
            width="500"
          >
          </el-table-column>
          <el-table-column
            property="word_number"
            label="字数"
            align="center"
            sortable
          >
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          class="pagination_box"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <div class="mydata_chart">
        <div id="font_num_chart" style="width: 780px; height: 750px"></div>
      </div>
    </div>
  </div>
</template>
<script scoped>
import * as echarts from "echarts";
import { information_list } from "@/utils/writer";
import * as common from "@/utils/common";
export default {
  data() {
    return {
      writerId: "", //所属部门
      dataList: [], //数据列表
      timeData: [], //时间筛选
      chartList: [], //图表数据列表
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 10, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      selectValue: "月", //选择的日期
      monthValue: "", //选择月
      weekValue: "", //选择周
      week: "", //周
      time: "week",
      total_num: "", //字数汇总
      numChart: "", //图表容器
      newDate: [],
      pickerOptions: {
        firstDayOfWeek: 1
      }
    };
  },
  computed: {
    date: {
      get() {
        let newDate = this.newDate;
        if (newDate && newDate.length <= 0) {
          let endDate = common.addDays(new Date(), -1);
          let beginDate = common.addDays(new Date());
          newDate = [beginDate, endDate];
        }
        return newDate;
      },
      set(newDate) {
        if (newDate && newDate.length > 0) {
          let weekStart = common.getWeekStartAndEnd(0, new Date(newDate[0]));
          let weekEnd = common.getWeekStartAndEnd(0, new Date(newDate[1]));
          this.newDate = [weekStart[0], weekEnd[1]];
        }
      }
    },

    dateType: {
      get() {
        return this.dateType;
      }
    },

    pickerOptionsType: {
      get() {
        let timeType = this.time;
        return this.pickerOptions;
      }
    }
  },
  mounted() {
    this.numChart = this.$echarts.init(
      document.getElementById("font_num_chart")
    );
    console.log("图表容器", this.numChart);
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;

    this.getDataList();
  },

  methods: {
    // 获取我的数据列表
    getDataList(time, timeType) {
      var that = this;
      var currentTime;
      if (time) {
        if (timeType == 3) {
          var month_one = time.slice(0, 7);
          var month_one_str = month_one + "-" + "01";
          var month_two = time.slice(11, 18);
          var month_two_arr = month_two.split("-");
          var last_year = month_two_arr[0];
          var last_month = month_two_arr[1];
          var lastDate = new Date(last_year, last_month, 0).getDate();
          var month_two_str = last_year + "-" + last_month + "-" + lastDate;
          currentTime = month_one_str + " - " + month_two_str;
        } else {
          currentTime = time;
        }
      } else {
        let monthNum = new Date().getMonth() + 1;
        let startTime = this.$moment(time)
          .month(monthNum - 1)
          .date(1)
          .startOf("month")
          .format("YYYY-MM-DD");

        //某月最后一天
        let endTime = this.$moment(time)
          .month(monthNum - 1)
          .date(1)
          .endOf("month")
          .format("YYYY-MM-DD");
        currentTime = startTime + " - " + endTime;
        timeType = 1;
      }

      let obj = {
        departmentuser_id: that.writerId,
        time: currentTime,
        type: timeType,
        page: 1,
        page_index: 10
      };
      information_list(obj).then(res => {
        console.log(res.data);
        if (res.data.code == 1) {
          that.total = res.data.data.connectionessay_list.length;
          that.dataList = res.data.data.connectionessay_list;
          that.chartList = res.data.data.connection_list;
          that.total_num = res.data.data.connection_list.total_num;
          this.fontNumChart();
          this.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 筛选月份
    monthChange(val) {
      var that = this;
      var timData = val[0] + " - " + val[1];
      that.getDataList(timData, 3);
    },
    // 筛选周
    weekChange(val) {
      var that = this;
      var timData = val[0] + " - " + val[1];
      that.getDataList(timData, 2);
    },
    // 筛选日
    dayChange(val) {
      var that = this;
      console.log(val);
      var timData = val[0] + " - " + val[1];
      that.getDataList(timData, 1);
    },
    // 字数数据表
    fontNumChart() {
      var that = this;
      var myChart = this.numChart;
      let xaxisData = [];
      let seriesData = [];
      xaxisData = that.chartList.A_x;
      seriesData = that.chartList.A_y;
      var option = {
        tooltip: {},
        grid: {
          left: "4%",
          right: "4%",
          top: "20%",
          bottom: "5%",
          containLabel: true
        },
        legend: {
          top: 50,
          left: 80,
          icon: "circle",
          data: ["字数数据表"]
        },
        xAxis: {
          data: xaxisData,
          splitLine: { show: true },
          axisLine: { show: true, textStyle: { color: "#304265" } },
          axisTick: {
            show: false,
            color: "#304265"
          }
        },
        yAxis: {
          type: "value",
          splitLine: { show: true },
          axisLine: { show: true, textStyle: { color: "#304265" } },
          axisTick: {
            show: true
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        series: [
          {
            name: "字数数据表",
            type: "bar",
            data: seriesData,
            // barCategoryGap:'5%',
            barWidth: 14,
            itemStyle: {
              borderRadius: [8, 8, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#3387FF"
                },
                {
                  offset: 0.9,
                  color: "#3387FF"
                }
              ])
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    // 计算页数的方法
    calcPageData() {
      // 计算页数，根据后台数据的条数和每页要显示的数量算出一共多少页，得0时设为1
      if (this.dataList.length > 1) {
        this.pageNum = Math.ceil(this.dataList.length / this.pageSize) || 1;
      }
      //数据分组
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.dataList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      // 获取到数据后显示第一页内容，数组下标是从0开始的，这里一定 要减去1，不然会丢失一组数据
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log("选择页数", val);
      // 重新计算页数并分组
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 注意数组是从0开始，页码别忘了减去1
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.title_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #ffffff;
  padding: 10px;
  border: 1px solid #e4e9f1;
  height: 40px;
}
.title_box_left {
  display: flex;
  flex-direction: row;
}
.data_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  margin-top: 10px;
  margin-right: 10px;
}
.my_data_from {
  display: flex;
  flex-direction: row;
}
.mydata_box {
  /* background: saddlebrown; */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 25px;
}
.mydata_table {
  width: 758px;
  /* width: 50%; */
}
.mydata_chart {
  background: #fff;
  width: 800px;
  /* width: 48%; */
}
.time_slect {
  margin-left: 10px;
}
.font_num_summary {
  line-height: 40px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterData.vue